import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import includes from 'lodash/includes';
import get from 'lodash/get';
import find from 'lodash/find';
import filter from 'lodash/filter';
import flow from 'lodash/flow';
import { getAppType } from '@vmos2/core';
import { selectJsonSetting, timeUtils } from '@vmos2/utils';

export const getDaySlotShift = (menuUUID, storeSettings, settings, timezone) => {
  const appType = getAppType();
  if (!includes(['delivery', 'online'], appType)) return 0;

  const currentDate = new Date();
  const currentTime = format(utcToZonedTime(currentDate, timezone), 'HH:mm');
  const setting = appType === 'delivery' ? 'dayslot.shift.delivery' : 'dayslot.shift.clickAndCollect';
  const menuDaySlotSiftSettingKey =
    appType === 'delivery' ? 'menu.dayslot.shift.delivery' : 'menu.dayslot.shift.clickAndCollect';
  let daySlotShift;
  try {
    daySlotShift = selectJsonSetting(menuDaySlotSiftSettingKey, settings, storeSettings);
    daySlotShift = get(daySlotShift, menuUUID);
  } catch (e) {
    daySlotShift = null;
  }

  if (!daySlotShift) {
    try {
      daySlotShift = JSON.parse(get(storeSettings, setting));
    } catch (e) {
      daySlotShift = null;
    }
  }

  let value = 0;
  try {
    let currentRange;
    if (get(daySlotShift, 'ranges')) {
      const rangesForToday = filter(
        get(daySlotShift, 'ranges', []),
        ({ weekday }) => +weekday === currentDate.getDay()
      );

      if (rangesForToday.length) {
        const rangeWithNoInterval = find(rangesForToday, ({ from }) => !from);
        if (rangeWithNoInterval && rangeWithNoInterval.value) {
          currentRange = rangeWithNoInterval;
        }
        const weekDayRange = find(rangesForToday, hours => timeUtils.isWithinInterval(hours, currentTime));
        if (weekDayRange && weekDayRange.value) {
          currentRange = weekDayRange;
        }
      } else {
        currentRange = flow([
          ranges => filter(ranges, ({ weekday }) => !weekday),
          ranges => find(ranges, hours => timeUtils.isWithinInterval(hours, currentTime)),
        ])(get(daySlotShift, 'ranges', []));
      }
    }

    daySlotShift = currentRange ? get(currentRange, 'value') : get(daySlotShift, 'default', 0);
    if (daySlotShift) {
      const shiftDate = currentDate.setDate(currentDate.getDate() + daySlotShift);
      const shiftDay = new Date(shiftDate).getDay();
      value = shiftDay === 0 ? 7 : shiftDay;
    }
  } catch (e) {
    value = 0;
  }
  return value;
};
